import { render, staticRenderFns } from "./detalle_seminarios.vue?vue&type=template&id=0322378f"
import script from "./detalle_seminarios.vue?vue&type=script&lang=js"
export * from "./detalle_seminarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports